import { render, staticRenderFns } from "./DestinItem.vue?vue&type=template&id=0035ad73&scoped=true&"
import script from "./DestinItem.vue?vue&type=script&lang=js&"
export * from "./DestinItem.vue?vue&type=script&lang=js&"
import style0 from "./DestinItem.vue?vue&type=style&index=0&id=0035ad73&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0035ad73",
  null
  
)

export default component.exports